import { useSelector } from 'react-redux';
import { selectCurrency, selectLocale } from './ducks/index.js';
import currencyFormatter from '~/libs/currency-formatter.js';

const FormattedAmount = ({ amount }) => {
	const currency = useSelector(selectCurrency);
	const locale = useSelector(selectLocale);

	return <>{currencyFormatter.format(amount, currency, locale)}</>;
};

export default FormattedAmount;
